import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@app/shared/services/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GraphQlService extends ApiService {
  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public executeQuery<T>(query: string): Observable<T> {
    return this.http.post<T>(this.endpoint(`graphql`), JSON.stringify({ query }), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json', // eslint-disable-line
        Accept: 'application/graphql',
      }),
    });
  }
}
